const ACTIONS = {
    OPEN_ATIVAR_CONTA: 'OPEN_ATIVAR_CONTA',
    CLOSE_ATIVAR_CONTA: 'CLOSE_ATIVAR_CONTA'
};

const INITIAL_STATE = {
    open: false,
    text: 'Verifique seu e-mail e digite o código que recebeu no campo abaixo para ativar o cadastro.',
    idUser: 0,
    email: ''
};

export function AtivarContaReducer(state = INITIAL_STATE, action) {
    switch (action.type) {
        case ACTIONS.OPEN_ATIVAR_CONTA:
            return {
                ...state,
                open: true,
                idUser: action.idUser,
                email: action.email,
            };
        case ACTIONS.CLOSE_ATIVAR_CONTA:
            return { ...state, open: false };
        default:
            return state;
    }
}
